import React from 'react';
import Tile from './Tile';

const TileGrid = ({ isVisible, scrollProgress }) => {
  const tiles = [
    { 
      id: 'about', 
      title: 'ABOUT ME', 
      gradient: 'linear-gradient(135deg, #FF7A7A 0%, #FF3CAC 100%)', 
      route: '/about',
      gridCol: 'col-span-2',
      gridRow: 'row-span-3',
      desktopCol: '1 / 3',
      desktopRow: '1 / 4',
      edgePosition: 'top-left'
    },
    { 
      id: 'consumer', 
      title: 'PRODUCT \nCONSUMER APPS', 
      gradient: 'linear-gradient(135deg, #89F7FE 0%, #66A6FF 100%)', 
      route: '/product-consumer',
      gridCol: 'col-span-5',
      gridRow: 'row-span-2',
      desktopCol: '3 / 8',
      desktopRow: '1 / 3',
      edgePosition: 'top-center'
    },
    { 
      id: 'startups', 
      title: 'STARTUPS', 
      gradient: 'linear-gradient(135deg, #F6D365 0%, #FDA085 100%)', 
      route: '/startups',
      gridCol: 'col-span-3',
      gridRow: 'row-span-3',
      desktopCol: '8 / 11',
      desktopRow: '1 / 4',
      edgePosition: 'top-right'
    },
    { 
      id: 'design', 
      title: 'DESIGN', 
      gradient: 'linear-gradient(135deg, #A18CD1 0%, #FBC2EB 100%)', 
      route: '/design',
      gridCol: 'col-span-2',
      gridRow: 'row-span-2',
      desktopCol: '1 / 3',
      desktopRow: '4 / 6',
      edgePosition: 'bottom-left'
    },
    { 
      id: 'b2b', 
      title: 'PRODUCT\nB2B', 
      gradient: 'linear-gradient(135deg, #84FAB0 0%, #8FD3F4 100%)', 
      route: '/product-b2b',
      gridCol: 'col-span-3',
      gridRow: 'row-span-3',
      desktopCol: '3 / 6',
      desktopRow: '3 / 6',
      edgePosition: 'left-edge'
    },
    { 
      id: 'contact', 
      title: 'CONTACT', 
      gradient: 'linear-gradient(135deg, #FDB99B 0%, #CF8BF3 100%)', 
      route: '/contact',
      gridCol: 'col-span-2',
      gridRow: 'row-span-2',
      desktopCol: '11 / 13',
      desktopRow: '1 / 3',
      edgePosition: 'top-right-edge'
    },
    { 
      id: 'devtool', 
      title: 'PRODUCT\nDEVTOOL/ ML', 
      gradient: 'linear-gradient(135deg, #C471F5 0%, #FA71CD 100%)', 
      route: '/product-devtool-ml',
      gridCol: 'col-span-5',
      gridRow: 'row-span-2',
      desktopCol: '6 / 11',
      desktopRow: '4 / 6',
      edgePosition: 'bottom-center'
    },
    { 
      id: 'run', 
      title: 'FOR\nFUN\nRUN', 
      gradient: 'linear-gradient(135deg, #74EBD5 0%, #9FACE6 100%)', 
      route: '/run',
      gridCol: 'col-span-2',
      gridRow: 'row-span-3',
      desktopCol: '11 / 13',
      desktopRow: '3 / 6',
      edgePosition: 'bottom-right'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto">
      {/* Desktop Layout - 12 column 5 row grid */}
      <div className="hidden lg:block" style={{ 
        margin: '40px',
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridTemplateRows: 'repeat(5, 120px)',
        gap: '20px'
      }}>
        {tiles.map((tile, index) => (
          <div 
            key={tile.id} 
            style={{ 
              gridColumn: tile.desktopCol, 
              gridRow: tile.desktopRow 
            }}
          >
            <Tile 
              tile={tile} 
              index={index} 
              isVisible={isVisible}
              scrollProgress={scrollProgress}
            />
          </div>
        ))}
      </div>

      {/* Tablet Layout - 2 column grid */}
      <div className="hidden md:block lg:hidden">
        <div className="grid grid-cols-2 gap-4">
          {tiles.map((tile, index) => (
            <div key={tile.id} className="h-48">
              <Tile 
                tile={tile} 
                index={index} 
                isVisible={isVisible}
                scrollProgress={scrollProgress}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Mobile Layout - single column stacked */}
      <div className="block md:hidden">
        <div className="grid grid-cols-1 gap-4">
          {tiles.map((tile, index) => (
            <div key={tile.id} className="h-48">
              <Tile 
                tile={tile} 
                index={index} 
                isVisible={isVisible}
                scrollProgress={scrollProgress}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TileGrid;
